import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import ArrowIcon from '@/assets/svg/chevron-down.svg';
import Link from '@/components/Link';
import { componentColors } from '@/layout/components/DealerWebHeader/constants';

import { DropdownProps } from './types';

function Dropdown({ label, link, isNewTab, onClick, children }: DropdownProps) {
  const [isOpened, setOpened] = useState(false);

  return (
    <Component>
      <Header>
        <StyledLink
          to={link}
          target={isNewTab ? '_blank' : '_self'}
          onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
            onClick?.(link, event)
          }
        >
          {label}
        </StyledLink>
        <Button isOpened={isOpened} onClick={() => setOpened(!isOpened)}>
          <ArrowIcon />
        </Button>
      </Header>

      <ContentWrapper isOpened={isOpened}>{children}</ContentWrapper>
    </Component>
  );
}

export default Dropdown;

const Component = styled.div`
  position: relative;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledLink = styled(Link)`
  font-size: 16px;
  line-height: 20px;
  color: ${componentColors.headerNav};
`;

const Button = styled.button<{ isOpened: boolean }>`
  padding-left: 20px;

  svg {
    transform: rotate(-90deg);

    path {
      stroke: ${componentColors.headerNav};
    }
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      svg {
        transform: rotate(0);
      }
    `};
`;

const ContentWrapper = styled.div<{ isOpened: boolean }>`
  display: none;

  ${({ isOpened }) =>
    isOpened &&
    css`
      display: block;
      margin-top: 20px;
    `}
`;
